import React, { useState } from 'react';
import projectsData from '../../projectsData';
import ProjectCard from '../ProjectCard/ProjectCard';
import './ProjectSection.css';

const ProjectSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToNext = () => {
    setCurrentIndex((currentIndex + 1) % projectsData.length);
  };

  const goToPrev = () => {
    setCurrentIndex((currentIndex - 1 + projectsData.length) % projectsData.length);
  };

  // Calculate translateX based on the current index
  const getTranslateX = () => {
    const percentage = -(100 * currentIndex);
    return `translateX(${percentage}%)`;
  };

  return (
    <section id="projects" className="project-section">
      <button onClick={goToPrev}>
        <img src="./chevron-left.png" alt="Previous" />
      </button>
      <div className="scroller">
        <div className="carousel-container" style={{ transform: getTranslateX(), transition: 'transform 0.5s ease' }}>
          {projectsData.map((project, index) => (
            <ProjectCard project={project} key={index} className={index === currentIndex ? 'active' : ''} />
          ))}
        </div>
      </div>
      <button onClick={goToNext}>
        <img src="./chevron-right.png" alt="Next" />
      </button>
    </section>
  );
};  

export default ProjectSection;



